import React, { useContext, useEffect, useState } from 'react';
//import * as Contacts from 'expo-contacts';
import { AuthContext } from '../context/AuthContext';
import { getShortcutDirectoy, getValidateNumbers, removeDirectory } from '../api/directory';


export const useContacts = () => {
    const {setLoading, tokenDecoded,setContacts,checkToken} = useContext(AuthContext)
    const [favoriteContacts, setFavoriteContacts] = useState();
    const deleteEspecialCharacter = (text) => {
        const regex = /[^+\d]/g;
        return text.replace(regex, '');
      }
    const addCountryCode = (phoneNumber) => {
        let number =  deleteEspecialCharacter(phoneNumber)
        if (number.length === 10) {
          /* obtener primeros 3 caracteres de un string */
          let countryCode = (tokenDecoded.phone_number).substring(0, 3);
          return countryCode + number;
        } else if (phoneNumber.length === 11) {
          return '+' + number;
        } else {
          return number;
        }
    }  

    function aleatory3colors() {

        var colors = [
          '#f44336',
          '#e91e63',
          '#9c27b0',
          '#2CB9B0',
          '#FE5E33',
          '#FFC641',
          '#FF87A2',
          '#442CB9',
        ]
        var random = Math.floor(Math.random() * colors.length);
        return colors[random];
      }
    
      const getFirstLetter = (string) => {
        return string.split(' ').map(word => word[0]).join('').substring(0, 2);
      }

      /* Get two first words of a string */
      const getTwoWords = (string) => {
        return string.split(' ').slice(0, 2).join(' ');
      }

      const sortContacts = (contacts) => contacts?.sort((a, b) => Number(b.existsRegistered) - Number(a.existsRegistered));
      const filterContact = (contacts) => contacts?.filter(item => item.existsRegistered === true);

      const getContacts = async()=>{

        // const { status } = await Contacts.requestPermissionsAsync();
        // if (status === 'granted') {
        //   const { data } = await Contacts.getContactsAsync({
        //     fields: [Contacts.Fields.PhoneNumbers],
        //   });
  
        //   if (data.length > 0) {
        //     const number = data.filter(item => {
        //       return Boolean(item.phoneNumbers) && (item.phoneNumbers[0].number).length > 9;
        //     });
        //     const numeros = number.map(item => {
        //       return {
        //         id : parseFloat(item.id),
        //         contactName: item.name,
        //         phoneNumber: addCountryCode(item.phoneNumbers[0].number)
        //       }
        //     });
            
  
        //    try {
        //         const {data} = await getValidateNumbers(numeros)
        //         setContacts( sortContacts([...data.data]) )
        //         setFilteredContacts( filterContact([...data.data]) )
        //         setLoading(false)
        //         return true
               
        //       } catch(error) {
        //         setLoading(false)
        //         //console.log(error.response )
        //         return false
        //     }
        //   }
        // }
       
      }



    // useEffect(() => {
    //     (async () => {
     
    //       const { status } = await Contacts.requestPermissionsAsync();
    //       if (status === 'granted') {
    //         await getContacts();
    //       }
   
    //     })();
    //   }, []);
    
      const getFavoriteContacts = async() => {
        checkToken()
        try {
          const {data} = await getShortcutDirectoy();
          // console.log("data.data",data.data)
          setFavoriteContacts(data.data)
          return true
        } catch(error) {
          console.log(error)
          setFavoriteContacts([])
        }
      }
      
  return {
    aleatory3colors,
    getFirstLetter,
    getFavoriteContacts,
    favoriteContacts,
    getTwoWords,
    getContacts,
    filterContact
  }
}
